<template>
  <div
    class="tabs">
    <ul
      class="tabs__nav">
      <li
        v-for="tab in tabList"
        :key="tab.id"
        :class="{ 'tabs__nav-item--active': tab.id === value }"
        class="tabs__nav-item"
        @click="$emit('input', tab.id)">
        {{ tab.name }}

        <span
          v-if="tab.counter"
          class="tabs__additional-text">
          {{ tab.counter }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LinearTabs',

  props: {
    value: {
      type: Number,
      required: true,
    },

    tabList: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.tabs__nav {
  display: flex;
  border-bottom: 2px solid rgba($color--basic-dark-gray, .25);
}

.tabs__nav-item {
  display: flex;
  position: relative;
  font-size: 19px;
  color: $color--basic-dark-gray;
  padding-bottom: 13px;
  transition: var(--transition-color);
  cursor: pointer;
  margin-right: 32px;
  font-weight: 500;

  &:last-child {
    margin-right: 0;
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    height: 2px;
    width: 100%;
    background-color: transparent;
    transition: var(--transition-color-bg);
  }

  &:hover {
    color: $color--basic-light-gray;
  }
}

.tabs__nav-item--active {
  color: $color--basic-white;

  &:after {
    background-color: $color--basic-blue;
  }
}

.tabs__additional-text {
  margin-left: 4px;
  font-size: 11px;
  font-weight: 500;
  color: $color--basic-dark-gray;
}

@media screen and #{$screen-less-than-480} {
  .tabs__nav {
    border-bottom: 0;
  }

  .tabs__additional-text {
    color: $color--basic-white;
  }

  .tabs__nav-item {
    margin-right: 8px;
    padding: 12px 16px;
    border-radius: 8px;
    background-color: rgba($color--basic-blue, .25);
    color: $color--basic-white;
    font-size: 15px;
    border: 1px solid rgba($color--basic-blue, .25);

    &:after {
      display: none;
    }

    &:hover {
      background-color: rgba($color--basic-blue, .45);
      border-color: $color--basic-blue;
      color: $color--basic-white;
    }
  }

  .tabs__nav-item--active {
    background-color: rgba($color--basic-blue, .45);
    border-color: $color--basic-blue
  }
}
</style>
